import { render, staticRenderFns } from "./Prospect_New.vue?vue&type=template&id=33673643&"
import script from "./Prospect_New.vue?vue&type=script&lang=js&"
export * from "./Prospect_New.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports